import React, { Component } from "react";
import { withFirebase } from "../Firebase/Firebase";
import "./FileUpload.css";

class FileUpload extends Component {
	state = {
		uploadPercentage: 0
	};
	getFileName() {
		if(! this.props.value) return "File Not Found";
		let filepath = this.props.value,
		index = filepath.lastIndexOf('/');
		return filepath.substring(index + 1);
	}
	handleFileUpload = e => {
		const { filePath } = this.props;
		const file = e.target.files[0];
		this._fileName = file.name;
		this.props.methods.uploadFile(
			`${filePath}${file.name}`,
			file,
			this.onProgress
		);
		this.setState({
			uploadPercentage: 0.1 // Start the progressbar before the first callback
		});
	};
	onProgress = percentage => {
		const { filePath } = this.props;
		this.setState({
			uploadPercentage: percentage
		});
		if (percentage === 100) {
			// Fire the onComplete event
			// console.log('p',this);
			this.props.onComplete(`${filePath}${this._fileName}`);
		}
	};
	deleteFile = e => {
		e.preventDefault();
		this.props.onComplete("");
	};
	render() {
		return (
			<div className="file-upload">
			{this.props.value ? (
				<div className="filename">
				<span>{this._fileName || this.getFileName()}</span>
				<a className="button -tiny -primary" href="/" onClick={this.deleteFile}>
				Remove
				</a>
				</div>
			) : this.state.uploadPercentage === 0 ||
			this.state.uploadPercentage === 100 ? (
				<input
				type="file"
				className="input"
				onChange={this.handleFileUpload}
				/>
			) : (
				<progress value={this.state.progress} max="100" />
			)}
			</div>
		);
	}
}

export default withFirebase(FileUpload);



// WEBPACK FOOTER //
// ./src/components/FileUpload/FileUpload.js